import React from 'react'
import { Footer , Header , Actualites} from '../index';
import './ToutesActualites.css' ;
import { Link } from 'react-router-dom';
import hawiya2 from'../../asserts/images/hawiya2.jpg';
import hawiya3 from'../../asserts/images/hawiya3.jpg';
import hawiya4 from'../../asserts/images/hawiya4.jpg';


export default function Actualite1(props) {
  return (
<>
<Header/>
<div className='containerActualité'>
        <div className='bgActualité'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-130px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy'}} className="container-fluid text-white text-center ">Actualités & événements</h1>
          <p ><Link className='linkActualité' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkActualité'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkActualité'
            to="/ToutesActualités">Actualités</Link></p></div>

      </div>
        <div className='description'>
        <div id="carouselBasicExample" className="carousel slide carousel-fade" data-bs-ride="carousel">
      {/* Indicators */}
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#carouselBasicExample" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
        <button type="button" data-bs-target="#carouselBasicExample" data-bs-slide-to="1" aria-label="Slide 2"></button>
        <button type="button" data-bs-target="#carouselBasicExample" data-bs-slide-to="2" aria-label="Slide 3"></button>
      </div>

      {/* Inner */}
      <div className="carousel-inner">
        {/* Single item */}
        <div className="carousel-item active">
          <img src={hawiya4} className="d-block w-100" alt="ACTUAITE1" />
          <div className="carousel-caption d-none d-md-block">
            <h5></h5>
          </div>
        </div>

        {/* Single item */}
        <div className="carousel-item">
          <img src={hawiya3} className="d-block w-100" alt="ACTUAITE1" />
          <div className="carousel-caption d-none d-md-block">
            <h5></h5>
          </div>
        </div>

        {/* Single item */}
        <div className="carousel-item">
          <img src={hawiya2} className="d-block w-100" alt="ACTUAITE1" />
          <div className="carousel-caption d-none d-md-block">
            <h5></h5>
          </div>
        </div>
      </div>
      {/* Inner */}

      {/* Controls */}
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselBasicExample" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselBasicExample" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
        <p className='PARAGACT'>
                Collaboration entre l’université de Carthage et University of national and world economy, Sofia ainsi que le TechPark de Sofia, Bulgarie

La récente visite à University of national and world economy, Sofia et au TechPark de Sofia a revêtu une importance capitale. Monsieur Samir Hamza, Directeur de l'INSAT, et Monsieur Hassen Mzali, Directeur de l'IHEC de Carthage, composaient l'équipe de l'Université de Carthage qui a conduit des réunions fructueuses avec les équipes de direction locales. Ces échanges ont jeté les bases de projets collaboratifs prometteurs entre l'Université de Carthage et University of national and world economy, Sofia ainsi qu'entre l'INSAT et le TechPark de Sofia, se concentrant notamment sur les nouvelles technologies et le développement de start-ups.

Des réunions fructueuses ont eu lieu au cours desquelles les parties ont partagé leurs visions respectives et identifié des domaines d'intérêt commun.

Les discussions ont mis l'accent sur la possibilité de créer des ponts entre la recherche académique et l'industrie, favorisant ainsi le développement de start-ups innovantes.

Les parties se sont engagées à élaborer des plans détaillés pour la mise en œuvre de projets collaboratifs dans les domaines de l'intelligence artificielle, de la cybersécurité et des technologies émergentes.
                </p>
        </div>


        <Footer/>
</>  )
}
